"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var Query_1 = require("./Query");

function Prefetch(_a) {
  var ignoreCache = _a.ignoreCache,
      props = tslib_1.__rest(_a, ["ignoreCache"]);

  var fetchPolicy = ignoreCache ? 'network-only' : undefined;
  return React.createElement(Query_1.Query, tslib_1.__assign({}, props, {
    fetchPolicy: fetchPolicy
  }), function () {
    return null;
  });
}

exports.Prefetch = Prefetch;